import React from "react";
import { Modal, Text, View } from "react-native";
import { useRsvpColors } from "../theme";
import RsvpPrimaryButton from "./RsvpPrimaryButton";

interface Props {
  visible: boolean;
  onKeep: () => void;
  onConfirm: () => void;
  loading?: boolean;
  // "decline" adapts the copy for turning down a waitlist spot offer.
  mode?: "cancel" | "decline";
}

/** Tenant-themed "are you sure" modal for cancelling an RSVP (or declining a spot offer). */
const RsvpCancelModal: React.FC<Props> = ({
  visible,
  onKeep,
  onConfirm,
  loading,
  mode = "cancel",
}) => {
  const colors = useRsvpColors();
  const declining = mode === "decline";

  return (
    <Modal visible={visible} transparent animationType="fade" onRequestClose={onKeep}>
      <View
        style={{
          flex: 1,
          backgroundColor: "rgba(0,0,0,0.5)",
          alignItems: "center",
          justifyContent: "center",
          padding: 16,
        }}
      >
        <View
          style={{
            width: "100%",
            maxWidth: 384,
            backgroundColor: colors.background,
            borderWidth: 1,
            borderColor: colors.cardBorder,
            borderRadius: 16,
            padding: 24,
          }}
        >
          <Text
            style={{
              color: colors.textPrimary,
              fontSize: 18,
              fontWeight: "700",
              marginBottom: 8,
            }}
          >
            {declining ? "Decline this offer?" : "Cancel your RSVP?"}
          </Text>
          <Text
            style={{
              color: colors.textMuted,
              fontSize: 15,
              marginBottom: 24,
            }}
          >
            {declining
              ? "The spot will be offered to the next player on the waitlist."
              : "You can RSVP again later if you change your mind."}
          </Text>
          <View style={{ flexDirection: "row", gap: 12 }}>
            <RsvpPrimaryButton
              title={declining ? "Keep Offer" : "Keep RSVP"}
              onPress={onKeep}
              disabled={loading}
              style={{ flex: 1 }}
            />
            <RsvpPrimaryButton
              title={declining ? "Decline Offer" : "Cancel RSVP"}
              onPress={onConfirm}
              loading={loading}
              style={{ flex: 1 }}
              testID="cancel-confirm"
            />
          </View>
        </View>
      </View>
    </Modal>
  );
};

export default RsvpCancelModal;
